<template>
  <el-dialog
    :title="$t('member.tab.memberInfo.bindPhoneTitle')"
    :visible="show"
    :close-on-click-modal="false"
    @closed="onCloseDialog"
    @close="$emit('update:show', false)"
  >
    <BaseElForm
      ref="formRef"
      :model="formData"
      :rules="formRules"
      label-position="left"
      label-width="120px"
    >
      <BaseElFormItem :label="$t('member.tab.memberInfo.phoneLabel')" prop="phone">
        <InternationalPhoneInput
          :phone.sync="formData.phone"
          :phone-country.sync="formData.phoneCountry"
          :enableInternationalPhone="enableInternationalPhone"
        />
      </BaseElFormItem>
    </BaseElForm>
    <div slot="footer">
      <BaseElButton
        style="width: 140px; margin-right: 36px"
        plain
        @click="$emit('update:show', false)"
      >
        {{ $t('member.tab.memberInfo.cancel') }}
      </BaseElButton>
      <BaseElButton
        style="width: 140px"
        type="primary"
        @click="updateAuthPhone"
      >
        {{ $t('member.tab.memberInfo.save') }}
      </BaseElButton>
    </div>
  </el-dialog>
</template>

<script>
import InternationalPhoneInput from '@/components/Input/InternationalPhoneInput.vue'
import { noEmptyRules } from '@/validation'
import formUtils from '@/utils/form'
import {
  DEFAULT_PHONE_COUNTRY,
  validateInternationalMemberPhone,
} from '@/utils/internationalPhone'

export default {
  name: 'BindPhoneDialog',
  components: {
    InternationalPhoneInput,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    enableInternationalPhone: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    formData: {
      phone: '',
      phoneCountry: DEFAULT_PHONE_COUNTRY,
    },
  }),
  computed: {
    formRules () {
      return {
        phone: [
          noEmptyRules(this.$t('member.memberCreate.phoneNumberRequired')),
          {
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const phoneState = this.getPhoneState(value)

              if (!phoneState.isValid) {
                return callback(new Error(phoneState.message))
              }

              return callback()
            },
          },
        ],
      }
    },
  },
  methods: {
    getPhoneState (phone, phoneCountry = this.formData.phoneCountry) {
      return validateInternationalMemberPhone({
        phone,
        country: phoneCountry,
      })
    },
    async updateAuthPhone () {
      if (!(await formUtils.checkForm(this.$refs.formRef))) return

      const phoneState = this.getPhoneState(this.formData.phone)

      this.$emit('bind', {
        phone: phoneState.payloadPhone,
        phoneCountryCode: this.enableInternationalPhone ? phoneState.phoneCountryCode : undefined,
        phoneCountry: this.enableInternationalPhone ? phoneState.country : undefined,
      })
    },
    onCloseDialog () {
      this.formData.phone = ''
      this.formData.phoneCountry = DEFAULT_PHONE_COUNTRY
      formUtils.resetForm(this.$refs.formRef)
    },
  },
}
</script>

<style lang="postcss" scoped></style>
